import React, { useState } from "react";
import { useFormMethods, useFormStatic} from "../DyanmicFormContext.tsx";
import { BaseStaticFieldModalProps } from "../DynamicFormTypes.ts";
import Modal from "../../Modal.tsx";

export const ExampleStaticFieldModal: React.FC<BaseStaticFieldModalProps> = React.memo(({
                                                                                 isOpen,
                                                                                 onClose,
                                                                                 fieldKey,
                                                                                 config
                                                                             }) => {
    const [targetFieldKey, setTargetFieldKey] = useState("");
    const [newValue, setNewValue] = useState("");

    const { formMethods } = useFormMethods()
    const {metaData, formPermissions} = useFormStatic()

    // Log everything to console for debugging
    React.useEffect(() => {
        if (isOpen) {
            console.log("Modal opened with fieldKey:", fieldKey);
            console.log("MetaData:", JSON.stringify(metaData, null, 2));
            console.log("All form values:", JSON.stringify(formMethods.getValues(), null, 2));
            console.log("config:", config);
        }
    }, [isOpen, fieldKey, metaData, formMethods, config]);

    const handleSetValue = () => {
        if (targetFieldKey && newValue) {
            if (!formPermissions.canEdit) {
                console.warn("not setting value", targetFieldKey,"to ", newValue, "due to allow auto or allow edits", formPermissions)
                return;
            }
            formMethods.setValue(targetFieldKey, newValue, { shouldDirty: true });
            // Log the updated value
            console.log(`Set field '${targetFieldKey}' to value: '${newValue}'`);
            console.log("Updated form values:", JSON.stringify(formMethods.getValues(), null, 2));
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Example Static Field Modal"
            maxWidth="lg"
        >
            <div className="space-y-4">
                <p className="text-sm text-gray-500">
                    Modal opened with fieldKey: <strong>{fieldKey}</strong>
                </p>

                {/* Field Key Input */}
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Target Field Key
                    </label>
                    <input
                        type="text"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        value={targetFieldKey}
                        onChange={(e) => setTargetFieldKey(e.target.value)}
                        placeholder="Enter field key to modify"
                    />
                </div>

                {/* Value Input */}
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        New Value
                    </label>
                    <input
                        type="text"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        value={newValue}
                        onChange={(e) => setNewValue(e.target.value)}
                        placeholder="Enter new value"
                    />
                </div>

                {/* Set Value Button */}
                <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                    onClick={handleSetValue}
                >
                    Set Field Value
                </button>

                {/* Debug Information */}
                <div className="mt-4 p-4 bg-gray-100 rounded-md">
                    <h4 className="text-sm font-medium text-gray-900 mb-2">Debug Information</h4>

                    <div className="space-y-2">
                        <div>
                            <p className="text-xs font-medium text-gray-700">Config:</p>
                            <pre className="text-xs bg-white p-2 rounded overflow-auto max-h-32">
                                {JSON.stringify(config, null, 2)}
                            </pre>
                        </div>

                        <div>
                            <p className="text-xs font-medium text-gray-700">MetaData:</p>
                            <pre className="text-xs bg-white p-2 rounded overflow-auto max-h-32">
                                {JSON.stringify(metaData, null, 2)}
                            </pre>
                        </div>

                        <div>
                            <p className="text-xs font-medium text-gray-700">All Form Values:</p>
                            <pre className="text-xs bg-white p-2 rounded overflow-auto max-h-32">
                                {JSON.stringify(formMethods.getValues(), null, 2)}
                            </pre>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
});